import ApiService from '@/services/core/api.service'

const SWallet = {
  async get (query = '') {
    return ApiService.get(`admin/merchants/wallets?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/merchants/wallets', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/merchants/wallets/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`admin/merchants/wallets/${payload.id}`)
  }
}

export default SWallet
